export default "__VITE_ASSET__CnCvckUa__ 1200w";